var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotionForecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0001,
    cy: 18,
    r: 16.5,
    stroke: "#00893F",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170:224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2173 11.2893L17.0701 11.3375L13.454 15.4456L10.2156 16.5053C8.44477 17.0847 7.51037 19.1034 8.13274 21.0055C8.68939 22.7067 10.3054 23.743 11.9073 23.5298L12.1519 27.7902L15.7341 26.618L15.4929 22.4165L15.7116 22.345L21.0567 23.5205L21.2039 23.4723C22.1526 23.1619 22.6533 22.0803 22.3198 21.0613L19.5427 12.5742C19.2091 11.5554 18.1659 10.9789 17.2173 11.2893ZM14.4648 25.6693L13.2676 26.061L13.1193 23.4776L14.3164 23.0859L14.4648 25.6693ZM17.3999 21.4118L15.6026 21.0165L12.0699 22.1724C10.9315 22.5449 9.67988 21.8529 9.27978 20.6302C8.87967 19.4074 9.48024 18.1098 10.6187 17.7373L14.1514 16.5813L15.3673 15.1998L17.3999 21.4118ZM21.1725 21.4367C21.2689 21.7311 21.1561 22.0411 20.9188 22.1857L18.7683 21.7128L16.2931 14.1483L17.748 12.4954C18.0252 12.4718 18.2992 12.6554 18.3955 12.9498L21.1725 21.4367Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2622 13.4386L21.7302 14.5881C22.3604 15.0801 22.8656 15.769 23.1389 16.6043C23.4123 17.4398 23.4121 18.2942 23.1945 19.0632L24.3031 19.6759C24.6491 18.61 24.6706 17.4045 24.2859 16.229C23.9013 15.0534 23.1714 14.0939 22.2622 13.4386Z",
    fill: "#00683A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2092 11.3939L22.6815 12.5341C23.8122 13.3164 24.7215 14.4884 25.1941 15.933C25.6669 17.3777 25.6263 18.8603 25.1767 20.1597L26.2763 20.7674C26.858 19.1745 26.925 17.342 26.3412 15.5576C25.7573 13.7733 24.62 12.3349 23.2092 11.3939Z",
    fill: "#00683A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170:224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20.4074,
    fill: "white",
    transform: "translate(5.16 11.9219) rotate(-18.1187)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionForecast);
export default __webpack_public_path__ + "static/media/promotion-forecast.90ec83ea.svg";
export { ForwardRef as ReactComponent };